import { FormControlLabel, Switch } from '@/ui';

import type { FC } from 'react';

import { SessionStatus } from '@/types/session';

// MEN-5349: Rails' session status filter is include-only, so "hide cancelled"
// is requested as every other status.
export const NON_CANCELLED_SESSION_STATUSES = [
  SessionStatus.ACTIVE,
  SessionStatus.RESCHEDULED,
  SessionStatus.DONE,
];

interface HideCancelledToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const HideCancelledToggle: FC<HideCancelledToggleProps> = ({
  checked,
  onChange,
}) => (
  <FormControlLabel
    control={
      <Switch
        checked={checked}
        color="primary"
        size="small"
        onChange={(event) => onChange(event.target.checked)}
      />
    }
    label="Hide Cancelled"
    slotProps={{ typography: { variant: 'body2' } }}
  />
);

export default HideCancelledToggle;
